import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import Page from './Page';
import Translation from './Translation';
import renderTemplate from '../utils/renderTemplate';

function renderCable(cable) {
	return (
		<table className="slx-mounting-planning__cable">
			<tbody>
				<tr className="slx-mounting-planning__cable-header">
					<th><Translation name="type-of-connection" /></th>
					<th><Translation name="description" /></th>
				</tr>

				{cable.map((e, i) => (
					<tr key={i} className={`slx-mounting-planning__cable-entry${e.isActive ? ' slx-mounting-planning__cable-entry--active' : ''}`}>
						<td>{e.type}</td>
						<td>{e.description}</td>
					</tr>
				))}
			</tbody>
		</table>
	);
}

function renderPower(power) {
	return (
		<table className="slx-mounting-planning__power">
			<tbody>
				<tr className="slx-mounting-planning__power-header">
					<th><Translation name="article-no" /></th>
					<th><Translation name="main-power-in-a" /></th>
					<th><Translation name="power-factor" /></th>
				</tr>

				{power.map((e, i) => (
					<tr key={i} className="slx-mounting-planning__power-entry">
						<td>{e.articleNumber}</td>
						<td>{e.mainPower}</td>
						<td>{e.powerFactor}</td>
					</tr>
				))}
			</tbody>
		</table>
	);
}

function renderTool({icon, title, tpl, params}, i) {
	return (
		<li key={i} className="slx-mounting-planning__tool">
			{icon && (
				<img src={icon} className="slx-mounting-planning__tool-icon" />
			)}
			<div className="slx-mounting-planning__tool-text">
				{title}
				<div>
					{renderTemplate(tpl, params)}
				</div>
			</div>
		</li>
	);
}

function Planning({content, startPageNumber, maxPageNumber}) {
	const {planningImage, planningCablechange, planningPower, planningTools} = content;
	return (
		<Page
			content={content}
			number={startPageNumber}
			maxPageNumber={maxPageNumber}
		>
			<div className="slx-mounting-planning">
				<h1><Translation name="planning" /></h1>

				{planningImage && (
					<img
						className="slx-mounting-planning__image"
						src={planningImage}
						/>
				)}

				{(planningCablechange || planningPower) && (
					<Fragment>
						<h2><Translation name="service-instructions-for-change-of-cable" /></h2>
						{planningCablechange && renderCable(planningCablechange)}
						{planningPower && renderPower(planningPower)}
					</Fragment>
				)}

				{planningTools && (
					<Fragment>
						<h2><Translation name="required-tools" /></h2>
						<ul className="slx-mounting-planning__tools">
							{planningTools.map(renderTool)}
						</ul>
					</Fragment>
				)}
			</div>
		</Page>
	);
}

Planning.propTypes = {
	content: PropTypes.object.isRequired,
	startPageNumber: PropTypes.number.isRequired,
	maxPageNumber: PropTypes.number.isRequired,
};

export default React.memo(Planning);

export function numPages() {
	return 1;
}
